/* narpine-pdp.js  --  PDP v2 only
   Real ATC = button[data-add-to-cart].custom-quick-view-btn
   Inner structure: <span.btn__text> + <div.ct-price-pdp>  (must be preserved)
*/
(function () {
  window.__NP_V = 46;
  if (!window.__npOrigFetch) window.__npOrigFetch = window.fetch.bind(window);
  if (!document.body.classList.contains('pdp-v2')) return;

  /* ---- gallery: dots + arrows, thumbnails removed ---- */

  /* media ids belonging to the currently selected colour, read from the
     theme's per-colour wrapper (data-handle="Black-true") */
  function npCurrentColourMediaIds(){
    var sel=document.querySelector('.selector-wrapper--fullwidth input:checked, .swatch__button input:checked');
    var colour=null;
    if(sel){ colour=sel.value; }
    if(!colour){
      var lbl=document.querySelector('.selector-wrapper--fullwidth .is-active, .swatch__button label.is-active');
      if(lbl) colour=(lbl.getAttribute('data-value')||lbl.textContent||'').trim();
    }
    if(!colour){
      var legend=document.querySelector('.selector-wrapper--fullwidth .selector-wrapper__value, .selector-wrapper--fullwidth .radio__legend__value');
      if(legend) colour=legend.textContent.trim();
    }
    if(!colour) return null;
    var wrap=document.querySelector('.product__images[data-handle^="'+colour+'-"]');
    if(!wrap) return null;
    return [].slice.call(wrap.querySelectorAll('.product__slide')).map(function(s){
      return s.getAttribute('data-media-id')||s.id||'';
    }).filter(Boolean);
  }

  /* ---- size guide as the last pill in the size row ---- */

  /* the colour legend shows "Select a colour" until one is chosen — hide that
     placeholder only, never the chosen value */
  (function npHideColourPlaceholder(){
    function tidy(){
      document.querySelectorAll('.radio__legend__value').forEach(function(el){
        var t=(el.textContent||'').trim().toLowerCase();
        el.classList.toggle('np-hide-legend', /^select a colou?r$/.test(t));
      });
    }
    tidy();
    setTimeout(tidy,900);
    document.addEventListener('click',function(){ setTimeout(tidy,250); },true);
    document.addEventListener('variant:change',function(){ setTimeout(tidy,250); });
  })();

  /* ---- "You might also like": move the CTA below the product grid ----
     .tabs__head wraps both the heading AND the grid, so a Liquid reorder
     still lands inside it. Relocate in the DOM instead. */

  /* "Made right" copy: the theme paints this paragraph rgb(111,103,92) from a
     stylesheet that loads after ours (3.88:1 on the stone bg — below AA).
     Set it inline so nothing can outrank it. */
  (function npStandardCopy(){
    function paint(){
      document.querySelectorAll('.video-with-text_rte, .video-with-text_rte p').forEach(function(el){
        el.style.setProperty('color','#3d3830','important');
      });
      document.querySelectorAll('.video-with-text_content .subheading, .video-with-text_content small').forEach(function(el){
        el.style.setProperty('color','#6b6252','important');
      });
    }
    paint();
    setTimeout(paint,900);
    setTimeout(paint,2500);
  })();
  (function npRelatedCta(){
    function move(){
      var cta=document.querySelector('.custom-tab-sct_discover');
      if(!cta || cta.__npMoved) return;
      var sec=cta.closest('.shopify-section');
      if(!sec) return;
      var cards=[].slice.call(sec.querySelectorAll('.product-item'))
        .filter(function(c){ return c.getBoundingClientRect().width>0; });
      if(!cards.length) return;
      var grid=cards[0].parentElement;
      if(!grid || !grid.parentElement) return;
      cta.__npMoved=true;
      grid.parentElement.insertBefore(cta, grid.nextSibling);
      cta.classList.add('np-related-cta');
    }
    move();
    setTimeout(move,1200);
    setTimeout(move,3000);
  })();
  (function npSizeGuidePill(){
    function init(){
      /* the pill must live in the same flex container as the size labels,
         otherwise it lands on its own line */
      var anyLabel=document.querySelector('.selector-wrapper--size.pdp-desk .radio__button');
      var row=anyLabel?anyLabel.parentElement:null;
      if(!row) row=document.querySelector('.selector-wrapper--size.pdp-desk .radio__fieldset');
      if(!row || row.__npSg) return;
      /* the theme's real trigger is .radio__legend__link.ruler-custom-cls
         inside a <product-modal> — clicking anything else opened the wrong
         dialog. Prefer the size-option one (option.position == 1). */
      var trigger=document.querySelector('product-modal .radio__legend__link.ruler-custom-cls')
               || document.querySelector('product-modal .radio__legend__link');
      if(!trigger) return;
      row.__npSg=true;
      var pill=document.createElement('button');
      pill.type='button';
      pill.className='np-size-guide-pill';
      pill.innerHTML='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        +'<path d="M2.5 15.5 15.5 2.5l6 6-13 13z"/><path d="M6 12l2 2M9 9l2 2M12 6l2 2"/></svg>'
        +'<span>Sizing</span>';
      pill.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        trigger.click();
      });
      row.appendChild(pill);
      /* hide the theme's original link (the whole product-modal block wrapper,
         NOT the dialog itself — the dialog is what our pill opens) */
      var origBlock=trigger.closest('.block__icon__container');
      if(origBlock) origBlock.classList.add('np-sg-original');
      else trigger.classList.add('np-sg-original');
    }
    init();
    setTimeout(init,1200);
    setTimeout(init,3000);
  })();

  /* ---- REMOVED 15 Sep 2026: npBundleBanner ----
     Removed from live on 09 Sep; this is the same removal on the demo theme,
     which had been left behind.

     It rewrote the first .np-bundle row from a hardcoded OFFERS map, so the
     page advertised a "SAVE ₹400 / buy any 2 tees" deal that no longer exists
     as a Shopify discount — the cart would never honour it.

     Offers are server-rendered per product by snippets/np-offer.liquid now.
     Do not reintroduce client-side rewriting of these rows. */

  /* ---- keep the "% OFF" badge in sync when the variant changes ----
     The badge is rendered server-side; the theme swaps the price and
     compare-at text on variant change, so recompute from those. */
  (function npSaveBadge(){
    function num(t){ return parseFloat(String(t||'').replace(/[^0-9.]/g,'')) || 0; }
    function sync(){
      var badge = document.querySelector('[data-save-badge]');
      if(!badge) return;
      var priceEl = document.querySelector('[data-product-price]');
      var compEl  = document.querySelector('[data-compare-price]');
      var price = num(priceEl && priceEl.textContent);
      var comp  = num(compEl && compEl.textContent);
      if(comp > price && price > 0){
        badge.textContent = Math.round((comp - price) / comp * 100) + '% OFF';
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden','');
      }
    }
    sync();
    ['variant:change','theme:variant:change'].forEach(function(ev){
      document.addEventListener(ev, function(){ setTimeout(sync, 120); });
    });
    var host = document.querySelector('.product__price');
    if(host){
      new MutationObserver(function(){ setTimeout(sync, 60); })
        .observe(host, {childList:true, subtree:true, characterData:true});
    }
    setTimeout(sync, 1200);
  })();
  (function npGallery(){
    function init(){
      /* there are several .product__images instances (desktop / mobile);
         all but one are display:none, and a hidden one collapses our controls
         to 0x0. Pick the instance that is actually laid out. */
      /* the theme renders one .product__images per colour (data-handle
         "Black-true" etc, 3 slides each) plus a catch-all with every image.
         Prefer the laid-out per-colour wrapper so the dashes match the
         selected colour instead of showing all 18. */
      var laidOut=[].slice.call(document.querySelectorAll('.product__images'))
        .filter(function(w){
          if(getComputedStyle(w).display==='none') return false;
          var t=w.querySelector('.product__slides');
          return t && t.getBoundingClientRect().height>50;
        });
      var wrap=laidOut.filter(function(w){
        var h=w.getAttribute('data-handle');
        return h && h.length>0;      /* per-colour wrapper */
      })[0] || laidOut[0];
      if(!wrap || wrap.__npSlider) return;
      var track=wrap.querySelector('.product__slides');
      if(!track) return;
      /* slides are stacked (width 0 until active) — do NOT filter on visibility.
         On mobile only the catch-all wrapper is laid out (all colours, 18
         slides), so narrow to the current colour's media ids instead. */
      var slides=[].slice.call(track.querySelectorAll('.product__slide'));
      if(!slides.length) slides=[].slice.call(track.querySelectorAll('.product__photo'));

      var colourIds=npCurrentColourMediaIds();
      if(colourIds && colourIds.length){
        var narrowed=slides.filter(function(s){
          var id=s.getAttribute('data-media-id')||s.id||'';
          return colourIds.indexOf(id)>-1;
        });
        if(narrowed.length){ slides=narrowed; }
      }
      if(slides.length<2) return;
      wrap.__npSlider=true;

      var idx=0;
      var nav=document.createElement('div');
      nav.className='np-gal-dots';
      slides.forEach(function(_,i){
        var d=document.createElement('button');
        d.type='button'; d.className='np-gal-dot'+(i===0?' is-active':'');
        d.setAttribute('aria-label','Image '+(i+1));
        d.addEventListener('click',function(){ go(i); });
        nav.appendChild(d);
      });
      /* the theme already ships .slider__button arrows and wires them to its
         own slider — reuse those instead of adding a second pair. Just keep
         our dot state in sync when they are used. */
      var themePrev=wrap.querySelector('.slider__button--prev');
      var themeNext=wrap.querySelector('.slider__button--next');
      if(themePrev) themePrev.addEventListener('click',function(){ setTimeout(syncFromDom,350); });
      if(themeNext) themeNext.addEventListener('click',function(){ setTimeout(syncFromDom,350); });
      function syncFromDom(){
        var a=slides.findIndex(function(s){ return s.classList.contains('media--active'); });
        if(a<0) return;
        idx=a;
        nav.querySelectorAll('.np-gal-dot').forEach(function(d,j){
          d.classList.toggle('is-active',j===a);
        });
      }
      /* mount on .product__slides — the element that actually has size
         (product-images can measure 0 and collapse absolute children) */
      /* mount the dashes on the WRAPPER, not the track: the track scrolls
         horizontally, so children pinned inside it scroll out of view. */
      var host=wrap;
      host.appendChild(nav);
      track.classList.add('np-gal');
      wrap.classList.add('np-gal-wrap');

      /* ---- 17 Sep 2026: WHAT COUNTS AS A SCROLLER ----
         `scrollWidth > clientWidth` is NOT enough. On desktop the theme's
         thumbs layout stacks the slides absolutely and parks every hidden
         one at left:100% - so scrollWidth reads ~2x clientWidth even though
         the track is overflow-x:hidden and cannot scroll at all. That false
         positive sent desktop down the "hide the other colours' slides"
         branch below, which set display:none on 18 of the 21 slides while
         the theme's own arrows and thumbnails still walked through all 21.
         Land on a hidden one and the gallery went white. Reported by the
         client on every product, desktop only.

         A track is a scroller only if it is actually allowed to scroll. */
      var trackOverflow=getComputedStyle(track).overflowX;
      var isScroller=(trackOverflow==='auto'||trackOverflow==='scroll')
                     && track.scrollWidth>track.clientWidth+4;

      function go(i){
        if(i<0) i=slides.length-1;
        if(i>=slides.length) i=0;
        idx=i;
        var target=slides[i];
        if(!target) return;
        if(isScroller){
          track.scrollTo({left:target.offsetLeft,behavior:'smooth'});
        } else {
          /* desktop: the gallery is the theme's stacked fader. Toggling
             media--active alone never worked here - the theme also keeps a
             media--hidden class (position:absolute; visibility:hidden), so a
             slide that is both stays invisible. The theme's own thumbnail
             link drives its slider correctly (classes, thumb highlight,
             zoom), so hand the click to that. Fall back to a full class swap
             only if there is no thumb for this slide. */
          var mid=target.getAttribute('data-media-id');
          var link=mid && wrap.querySelector('.product__thumb__link[data-media-id="'+mid+'"]');
          if(link){
            link.click();
          } else {
            slides.forEach(function(s){ s.classList.remove('media--active'); s.classList.add('media--hidden'); });
            target.classList.remove('media--hidden');
            target.classList.add('media--active');
          }
        }
        nav.querySelectorAll('.np-gal-dot').forEach(function(d,j){
          d.classList.toggle('is-active',j===i);
        });
      }
      /* keep dots in sync when the user swipes.
         Only a REAL scroller (see isScroller above) gets the other colours'
         slides hidden - that is a mobile swipe-track concern. On desktop the
         catch-all gallery is meant to hold every image (see the CSS comment
         "one gallery for all images" in narpine-pdp-2.css), so nothing may
         be hidden there. */
      if(isScroller){
        /* hide the slides that belong to other colours so the swipe track
           only contains this colour's images (otherwise 18 slides scroll
           past 3 dots and the gallery feels broken) */
        var keep=slides;
        [].slice.call(track.querySelectorAll('.product__slide')).forEach(function(s){
          if(keep.indexOf(s)===-1){ s.style.display='none'; }
          else { s.style.display=''; }
        });
        var sync=function(){
          var best=0,bestD=Infinity;
          keep.forEach(function(s,j){
            var d=Math.abs(s.offsetLeft-track.scrollLeft);
            if(d<bestD){bestD=d;best=j;}
          });
          if(best!==idx){
            idx=best;
            nav.querySelectorAll('.np-gal-dot').forEach(function(d,j){
              d.classList.toggle('is-active',j===best);
            });
          }
        };
        track.addEventListener('scroll',sync,{passive:true});
        setTimeout(sync,300);
      } else {
        /* not a scroller: make sure nothing is left hidden from an earlier
           pass (init re-runs on resize, and a phone-width pass will have
           set display:none on the other colours' slides). */
        [].slice.call(track.querySelectorAll('.product__slide')).forEach(function(s){
          if(s.style.display==='none') s.style.display='';
        });
      }
    }
    init();
    setTimeout(init,1200);
    setTimeout(init,3000);
    var rt=null;
    window.addEventListener('resize',function(){
      clearTimeout(rt);
      rt=setTimeout(init,300);   /* the visible instance swaps at the breakpoint */
    });
    function reinit(){
      /* drop the old dash strip so it is rebuilt for the new colour */
      document.querySelectorAll('.np-gal-dots').forEach(function(n){ n.remove(); });
      document.querySelectorAll('.product__images, .product__slides').forEach(function(el){
        el.__npSlider=false; el.classList.remove('np-gal','np-gal-wrap');
      });
      init();
    }
    document.addEventListener('variant:change',function(){ setTimeout(reinit,450); });
    document.addEventListener('click',function(e){
      if(e.target.closest && e.target.closest('.swatch__button, .selector-wrapper--fullwidth label')){
        setTimeout(reinit,600);
      }
    },true);
  })();

  /* publish the real header height so CSS can clear the absolute overlay header */
  (function npHeaderVar(){
    function set(){
      var h=document.querySelector('.theme__header, #header, header');
      if(!h) return;
      var px=Math.round(h.getBoundingClientRect().height);
      if(px>0) document.documentElement.style.setProperty('--np-header-h', px+'px');
    }
    set();
    window.addEventListener('load',set);
    window.addEventListener('resize',set);
    setTimeout(set,1200);
  })();

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var scope = document.querySelector('.product__form__outer') || document;
    var btn = Array.prototype.slice.call(
        document.querySelectorAll('.product__block--buttons button[data-add-to-cart].custom-quick-view-btn')
      ).filter(function (b) { return !b.closest('product-modal') && !b.closest('dialog') && !b.closest('.product__selectors'); })[0]
      || document.querySelector('button[data-add-to-cart].custom-quick-view-btn');
    /* hide any other submit for the same form (variant snippet renders its own) */
    document.querySelectorAll('button[data-add-to-cart].custom-quick-view-btn').forEach(function (b) {
      if (b.closest('product-modal') || b.closest('dialog')) return;
      if (b !== btn) {
        var box = b.closest('.product__submit__buttons') || b;
        box.classList.add('np-dupe-atc');
      }
    });
    var jsonEl = document.querySelector('[data-product-json]');
    if (!btn || !jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var textEl = btn.querySelector('[data-add-to-cart-text]');
    var priceEl = btn.querySelector('.ct-price-pdp');

    /* dock the button block */
    var blk = btn.closest('.product__block--buttons');
    if (blk) blk.classList.add('np-atc-dock');

    /* ---- preselected variant handling ----
       If the URL carries ?variant= (from cart, share links, back-button),
       honour it by checking the matching colour+size radios so the ATC is
       enabled. Otherwise clear Shopify's default so the shopper chooses. */
    var urlVariant = new URLSearchParams(location.search).get('variant');
    var preVar = urlVariant && (product.variants || []).find(function (v) {
      return String(v.id) === String(urlVariant);
    });
    if (preVar) {
      preVar.options.forEach(function (optVal, k) {
        document.querySelectorAll('.pdp-desk input[type="radio"][data-single-option-selector]')
          .forEach(function (r) {
            var pos = r.dataset.optionPosition || (r.closest('[data-option-position]') || {}).dataset && (r.closest('[data-option-position]')).dataset.optionPosition;
            if (String(r.value) === String(optVal)) {
              /* only check within the correct option group */
              var grp = r.closest('.selector-wrapper');
              if (grp) r.checked = true;
            }
          });
      });
    } else {
      document.querySelectorAll('.pdp-desk input[type="radio"][data-single-option-selector]')
        .forEach(function (r) { r.checked = false; });
      document.querySelectorAll('.pdp-desk [data-option-value]')
        .forEach(function (el) { el.textContent = ''; });
    }

    /* the theme reveals .custom-hide-on-loading via jQuery, which can fail;
       reveal the desk selector wrappers ourselves */
    document.querySelectorAll('.selector-wrapper.pdp-desk, .product__block--buttons').forEach(function (el) {
      el.classList.remove('custom-hide-on-loading');
      if (el.style && el.style.display === 'none') el.style.removeProperty('display');
    });

    /* legends in this render path have no value element; add one */
    document.querySelectorAll('.pdp-desk .radio__legend').forEach(function (lg) {
      if (!lg.querySelector('[data-option-value]')) {
        var sm = document.createElement('small');
        sm.className = 'radio__legend__value';
        sm.setAttribute('data-option-value', '');
        lg.appendChild(sm);
      }
    });

    /* size-guide trigger renders as a sibling block; move it into the SIZE legend */
    (function () {
      var wrap = document.querySelector('.selector-wrapper--size.pdp-desk');
      var modal = document.querySelector('product-modal.test-order');
      var lg = wrap && wrap.querySelector('.radio__legend');
      if (lg && modal) lg.appendChild(modal);
    })();

    function selected() {
      var out = {};
      document.querySelectorAll('.pdp-desk input[type="radio"][data-single-option-selector]:checked')
        .forEach(function (r) { out[r.dataset.index] = r.value; });
      return out;
    }

    function labelFor(pos) {
      var el = document.querySelector('.pdp-desk[data-option-position="' + pos + '"] .radio__legend__option-name');
      return el ? el.textContent.trim() : ((product.options || [])[pos - 1] || '');
    }

    function money(cents) {
      return '₹ ' + (Math.round(cents) / 100).toLocaleString('en-IN');
    }

    function galEl() {
      return document.querySelector('product-images.pdp-desk.main-all-images')
          || document.querySelector('product-images.pdp-desk');
    }
    function activateSlide(target) {
      var gal = galEl();
      if (!gal || !target || target.classList.contains('media--active')) return;
      gal.querySelectorAll('.product__slide.media--active').forEach(function (s) {
        s.classList.remove('media--active');
      });
      target.classList.add('media--active');
    }
    function clickThumb(link) {
      if (!link || link.getAttribute('aria-current') === 'true') return false;
      var prevent = function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-thumb-link]')) e.preventDefault();
      };
      document.addEventListener('click', prevent, { once: true });
      link.click();
      return true;
    }
    function showMediaForColour(val) {
      var gal = galEl();
      if (!gal || !val) return;
      var target = null;
      gal.querySelectorAll('.product__slide').forEach(function (sl) {
        if (target) return;
        var im = sl.querySelector('img');
        if (im && (im.alt || '').trim().toLowerCase() === val.trim().toLowerCase()) target = sl;
      });
      if (!target) return;
      var mid = target.getAttribute('data-media-id');
      var link = mid && gal.querySelector('[data-thumb-link][data-media-id="' + mid + '"]');
      if (!clickThumb(link)) activateSlide(target);
    }

    function update() {
      var sel = selected();
      var opts = product.options || [];
      var missing = [];

      for (var i = 1; i <= opts.length; i++) {
        if (!sel['option' + i]) missing.push(labelFor(i));
      }

      /* mirror chosen value beside each legend */
      document.querySelectorAll('.pdp-desk [data-option-value]').forEach(function (el) {
        var w = el.closest('[data-option-position]');
        if (!w) return;
        el.textContent = sel['option' + w.dataset.optionPosition]
          || (w.dataset.optionPosition === '1' ? 'Select a colour' : '');
      });

      if (sel['option1']) showMediaForColour(sel['option1']);

      if (missing.length) {
        btn.disabled = true;
        btn.classList.add('np-disabled');
        if (textEl) textEl.textContent = 'Select ' + missing.map(function (m) { return m.toLowerCase(); }).join(' & ');
        if (priceEl) priceEl.style.display = 'none';
        return;
      }

      var match = (product.variants || []).find(function (v) {
        return v.options.every(function (o, k) { return o === sel['option' + (k + 1)]; });
      });

      if (!match || !match.available) {
        btn.disabled = true;
        btn.classList.add('np-disabled');
        if (textEl) textEl.textContent = 'Sold out';
        if (priceEl) priceEl.style.display = 'none';
        return;
      }

      if (btn.form && match) {
        var __idi = btn.form.querySelector('input[name="id"]');
        if (!__idi) {
          __idi = document.createElement('input');
          __idi.type = 'hidden';
          __idi.name = 'id';
          btn.form.appendChild(__idi);
        }
        __idi.value = match.id;
      }
      btn.disabled = false;
      btn.classList.remove('np-disabled');
      /* was 'Add for' — the price used to sit inside the button and finish the
         sentence. Price removed from the button 06 Sep 2026, so the label has
         to stand on its own. */
      if (textEl) textEl.textContent = 'Add to cart';
      if (priceEl) priceEl.style.display = '';
    }

    /* route add-to-cart through the theme's own flow so its cart drawer opens
       (theme listens for 'theme:cart:add' with the button and reads button.form) */
    /* self-contained add: POST /cart/add.js, re-render the cart-drawer section,
       open it. Avoids the theme's viewport-branched add path (which tears down
       the drawer node on mobile) and the legacy fetch intercept. */
    /* FIXED 06 Sep 2026 — CART_SECTION was hardcoded to
       'sections--18168555798728__cart-drawer'. That is the section instance id
       of a DIFFERENT theme; this theme's is sections--18200707137736__…, so
       '/?section_id=' + CART_SECTION answered 404 with a zero-byte body. The
       add itself succeeded, but the re-render had nothing to parse, so the
       drawer kept its server-rendered empty markup AND its is-loading class —
       "Your Cart is Empty" over a cart that actually had items, with the
       spinner state making it flicker on scroll.

       Section instance ids change whenever a theme is duplicated or its
       section groups are edited, so they must never be written down. Read it
       off the DOM at runtime instead. */
    function npCartSectionId() {
      var live = document.querySelector('#cart-drawer');
      var host = live && live.closest ? live.closest('[id^="shopify-section-"]') : null;
      if (!host) host = document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]');
      return host ? host.id.replace(/^shopify-section-/, '') : null;
    }

    window.__npRefreshCart = function (openAfter) { return refreshCartDrawer(openAfter); };
    function refreshCartDrawer(openAfter) {
      var origFetch = window.__npOrigFetch || window.fetch;
      var section = npCartSectionId();

      /* Never leave the drawer mid-load: whatever happens below, drop
         is-loading and honour openAfter, so a failed refresh degrades to a
         stale-but-usable drawer rather than a stuck spinner. */
      function settle() {
        var live = document.querySelector('#cart-drawer');
        if (live) live.classList.remove('is-loading');
        if (openAfter) openDrawer();
      }

      if (!section) { settle(); return Promise.resolve(); }

      return origFetch('/?section_id=' + section, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('cart section ' + section + ' -> ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#cart-drawer');
          var live = document.querySelector('#cart-drawer');
          if (fresh && live) {
            live.innerHTML = fresh.innerHTML;
            live.className = fresh.className;
          } else if (fresh && !live) {
            document.body.appendChild(fresh);
          }
          /* no theme:cart:change here — the theme's listener re-renders the
             drawer body from its api-cart-items partial and wipes our band/widgets */
          settle();
        })
        .catch(function (err) {
          if (window.console && console.warn) console.warn('[np] cart refresh failed:', err);
          settle();
        });
    }
    /* persistent overlay + one set of handlers, built once */
    var npOverlay = document.getElementById('np-cart-overlay');
    if (!npOverlay) {
      npOverlay = document.createElement('div');
      npOverlay.id = 'np-cart-overlay';
      document.body.appendChild(npOverlay);
    }
    function closeDrawer() {
      var d = document.querySelector('#cart-drawer');
      if (d) d.classList.remove('is-open');
      npOverlay.classList.remove('is-visible');
      document.body.classList.remove('np-cart-open');
    }
    npOverlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    /* delegated close for the drawer's × (survives innerHTML re-renders) */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-drawer [data-cart-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });
    function openDrawer() {
      var d = document.querySelector('#cart-drawer');
      if (!d) return;
      d.classList.add('is-open');
      npOverlay.classList.add('is-visible');
      document.body.classList.add('np-cart-open');
      document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true, detail: { target: d } }));
    }
    function addToCart(sourceBtn) {
      if (!sourceBtn || sourceBtn.disabled || sourceBtn.classList.contains('np-disabled')) return;
      update(); /* ensure hidden id input is current */
      var form = sourceBtn.form;
      if (!form) return;
      /* ---- 16 Sep 2026: MOBILE NOW USES THE SAME PATH AS DESKTOP ----
         WHY THIS CHANGED - read before touching it.

         Mobile used to do a native form submit here. That posts to /cart/add
         (the FORM endpoint). Normally that redirects to the cart page and
         Shopify counts the add on the redirect - but the interceptor in
         snippets/product-variant-options.liquid deliberately blocks that
         redirect to keep the slide-out drawer. Net result: the item went in
         the cart and Shopify was never told.

         That interceptor tried to compensate by calling
         Shopify.analytics.publish('product_added_to_cart', ...). It worked for
         six days (14-19 Aug 2026) and then Shopify stopped honouring it.
         Verified 16 Sep 2026: the publish call still fires on every mobile add
         and emits no network traffic at all.

         /cart/add.js is the AJAX cart API - Shopify records the add itself, so
         there is nothing for us to publish and nothing to regress. Desktop has
         always used it, and so has the collection-page quick-add; both kept
         reporting correctly right through the outage.

         So the branch is gone and mobile falls through to the same code below.
         Do not reintroduce a native submit here. If the drawer misbehaves on
         mobile, fix the drawer - not the endpoint. */
      var fd = new FormData(form);
      if (!fd.get('id')) return; /* no variant -> guard */
      var origFetch = window.__npOrigFetch || window.fetch;
      sourceBtn.classList.add('is-loading');
      origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd,
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () { return refreshCartDrawer(true); })
        .then(function () {
          /* the theme's fetch hook re-renders the drawer from its partial
             shortly after an add, wiping the band/widgets; heal twice */
          setTimeout(function () {
            if (!document.querySelector('#cart-drawer .np-cart-band')) refreshCartDrawer(false);
          }, 700);
          setTimeout(function () {
            if (!document.querySelector('#cart-drawer .np-cart-band')) refreshCartDrawer(false);
          }, 1600);
        })
        .catch(function (e) {
          console.warn('[np] add failed', e);
          alert((e && e.description) || 'Could not add to cart.');
        })
        .then(function () { sourceBtn.classList.remove('is-loading'); });
    }

    /* stop native submit entirely: neutralise the button type and guard the form */
    if (btn.form) {
      btn.form.addEventListener('submit', function (e) {
        /* 16 Sep 2026: now blocks on BOTH widths. It used to let the submit
           through on mobile so the theme interceptor could do the add - but
           the theme's mobile path posts to /cart/add (the form endpoint) with
           the redirect suppressed, which Shopify never records. We do the add
           ourselves against /cart/add.js instead, which Shopify does record. */
        if (document.body.classList.contains('pdp-v2')) {
          e.preventDefault(); e.stopPropagation();
        }
      }, true);
    }

    /* ---- mobile add, 16 Sep 2026 ----
       Capture phase, and stopImmediatePropagation, because the theme binds its
       own click listener to this button first; on desktop that listener wins
       and we deliberately ride it (see below). On mobile we must beat it, or
       the theme performs its /cart/add submit and the add goes unreported. */
    btn.addEventListener('click', function (e) {
      if (window.innerWidth >= 768) return;
      if (!document.body.classList.contains('pdp-v2')) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addToCart(btn);
    }, true);

    btn.addEventListener('click', function (e) {
      if (window.innerWidth >= 768) {
        e.preventDefault();
        e.stopPropagation();
        /* the theme's listener (bound first) has already started the add and
           synchronously disabled the button, so our own fetch chain can never
           run from here. Ride the theme's add; layer our full group render
           (band + widgets) on top once it settles, with heals for slow adds. */
        setTimeout(function () { refreshCartDrawer(true); }, 900);
        setTimeout(function () {
          if (!document.querySelector('#cart-drawer .np-cart-band')) refreshCartDrawer(false);
        }, 2200);
        setTimeout(function () {
          if (!document.querySelector('#cart-drawer .np-cart-band')) refreshCartDrawer(false);
        }, 3800);
      }
      /* mobile: allow native submit -> theme interceptor adds + opens our drawer */
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('input[data-single-option-selector]')) update();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pdp-desk label')) setTimeout(update, 0);
    });

    /* ---- ORGANIC COTTON badge on the active slide ---- */
    (function () {
      var slide = document.querySelector('product-images.pdp-desk.main-all-images')
               || document.querySelector('product-images.pdp-desk');
      if (slide && !slide.querySelector(':scope > .np-media-badge')) {
        /* per-product label: set data-np-badge on the product section from the
           metafield; falls back to the first key-feature, then a default. */
        var label = null;
        var host = document.querySelector('[data-np-badge]');
        if (host) label = (host.getAttribute('data-np-badge') || '').trim();
        /* the section supplies the material label; don't fall back to a key
           feature (that duplicated the feature cards below) */
        if (!label) label = 'Organic Cotton';
        if (label.toLowerCase() !== 'none') {
          var badge = document.createElement('span');
          badge.className = 'np-media-badge';
          badge.textContent = label;
          slide.appendChild(badge);
        }
      }
    })();

    /* ---- MRP note beside price ---- */
    (function () {
      var pr = document.querySelector('.product__block--price [data-product-price], .product__block--price .price');
      if (pr && !document.querySelector('.np-tax-note')) {
        var n = document.createElement('span');
        n.className = 'np-tax-note';
        n.textContent = 'MRP incl. of all taxes';
        pr.parentNode.appendChild(n);
      }
    })();


    /* ---- thumb highlight follows the active slide ---- */
    (function () {
      var gal = document.querySelector('product-images.pdp-desk.main-all-images')
             || document.querySelector('product-images.pdp-desk');
      if (!gal) return;
      function sync() {
        var act = gal.querySelector('.product__slide.media--active');
        var id = act && act.getAttribute('data-media-id');
        if (!id) return;
        gal.querySelectorAll('[data-thumb-item]').forEach(function (t) {
          var link = t.querySelector('[data-media-id]');
          var on = link && link.getAttribute('data-media-id') === id;
          t.classList.toggle('is-active', on);
          if (link) link.setAttribute('aria-current', on ? 'true' : 'false');
          if (on) {
            var holder = t.closest('.product__thumbs__holder');
            if (holder) {
              var hr = holder.getBoundingClientRect();
              var tr = t.getBoundingClientRect();
              if (tr.left < hr.left || tr.right > hr.right) {
                holder.scrollLeft += (tr.left - hr.left) - (hr.width - tr.width) / 2;
              }
            }
          }
        });
      }
      sync();
      new MutationObserver(sync).observe(gal, { subtree: true, attributes: true, attributeFilter: ['class'] });
    })();

    /* ---- quantity stepper wired to the form's hidden qty input ---- */
    (function () {
      var item = btn && btn.closest('.product__submit__item');
      var form = btn && btn.form;
      var qtyInput = form && form.querySelector('input[name="quantity"]');
      if (!item || !qtyInput || item.querySelector('.np-qty')) return;
      var box = document.createElement('div');
      box.className = 'np-qty';
      box.innerHTML = '<button type="button" data-np-minus aria-label="Decrease quantity">−</button>' +
                      '<input type="number" min="1" value="' + (qtyInput.value || 1) + '" aria-label="Quantity">' +
                      '<button type="button" data-np-plus aria-label="Increase quantity">+</button>';
      item.insertBefore(box, btn);
      var field = box.querySelector('input');
      function setQty(v) {
        v = Math.max(1, parseInt(v, 10) || 1);
        field.value = v;
        qtyInput.value = v;
      }
      box.querySelector('[data-np-minus]').addEventListener('click', function () { setQty(+field.value - 1); });
      box.querySelector('[data-np-plus]').addEventListener('click', function () { setQty(+field.value + 1); });
      field.addEventListener('change', function () { setQty(field.value); });
    })();

    /* ---- floating add-to-cart bar: appears past the buy box ---- */
    (function () {
      var block = btn && btn.closest('.product__block--buttons');
      if (!block || document.querySelector('.np-sticky-bar')) return;
      var bar = document.createElement('div');
      bar.className = 'np-sticky-bar';
      bar.hidden = true;
      bar.innerHTML =
        '<div class="np-sticky-bar__in">' +
          '<img class="np-sticky-bar__thumb" alt="">' +
          '<div class="np-sticky-bar__info">' +
            '<div class="np-sticky-bar__title"></div>' +
            '<div class="np-sticky-bar__sub"></div>' +
          '</div>' +
          '<div class="np-sticky-bar__price"></div>' +
          '<button type="button" class="np-sticky-bar__btn"></button>' +
        '</div>';
      document.body.appendChild(bar);
      var tEl = bar.querySelector('.np-sticky-bar__title');
      var subEl = bar.querySelector('.np-sticky-bar__sub');
      var priceEl = bar.querySelector('.np-sticky-bar__price');
      var barBtn = bar.querySelector('.np-sticky-bar__btn');
      var imgEl = bar.querySelector('.np-sticky-bar__thumb');
      tEl.textContent = product.title || '';

      function refreshBar() {
        var sel = selected();
        var col = sel.option1, siz = sel.option2;
        subEl.textContent = col ? (col + (siz ? ' · Size ' + siz : '')) : 'Choose colour & size';
        var act = document.querySelector('product-images.pdp-desk .product__slide.media--active img');
        if (act && (act.currentSrc || act.src)) imgEl.src = act.currentSrc || act.src;
        var match = null;
        if (col && siz) {
          match = (product.variants || []).find(function (v) {
            return v.options[0] === col && v.options[1] === siz;
          });
        }
        if (match && match.available) {
          priceEl.textContent = money(match.price);
          barBtn.textContent = 'Add — ' + col + ' / ' + siz;
          barBtn.classList.remove('np-disabled');
        } else if (match) {
          priceEl.textContent = money(product.price);
          barBtn.textContent = 'Sold out';
          barBtn.classList.add('np-disabled');
        } else {
          priceEl.textContent = money(product.price);
          barBtn.textContent = 'Select colour & size';
          barBtn.classList.add('np-disabled');
        }
      }
      barBtn.addEventListener('click', function () {
        if (barBtn.classList.contains('np-disabled')) {
          (document.querySelector('.product__selectors') || block)
            .scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          addToCart(btn);
        }
      });
      document.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-single-option-selector]')) refreshBar();
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.pdp-desk label')) setTimeout(refreshBar, 0);
      });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.hidden = !(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(block);
      refreshBar();
    })();

    /* ---- cross-sell: move the discover button into the heading row ---- */
    (function () {
      var head = document.querySelector('.custom-related-pro-sct .tabs__head');
      var disc = document.querySelector('.custom-related-pro-sct .custom-tab-sct_discover');
      if (head && disc && !head.contains(disc)) head.appendChild(disc);
    })();

    update();
  });

  /* ---- default colour + size selected on load. 15 Sep 2026 ----
     The PDP opened with nothing selected, so the add-to-cart sat in its
     "Select color & size" state and the size row had no box on it. The
     client asked for a live button and a real default selection.

     The form's own input[name=id] already carries a valid variant on load
     (Shopify's selected_or_first_available_variant), so this only mirrors
     that into the radio groups - it does not invent a selection, and it
     does nothing at all if the shopper arrived on a ?variant= URL or the
     theme already checked something.

     It writes to form controls, not to rendered copy. Do not extend it to
     rewrite prices, offers or labels - that is the mistake np-offer.liquid
     exists to prevent. */
  (function npDefaultVariant(){

    function firstSelectable(inputs){
      for (var i = 0; i < inputs.length; i++){
        var input = inputs[i];
        if (input.disabled) continue;
        var label = input.parentElement &&
                    input.parentElement.querySelector('label[for="' + input.id + '"]');
        if (!label) label = input.nextElementSibling;
        if (label && /unavailable|sold-?out|is-disabled/i.test(label.className || '')) continue;
        return input;
      }
      return null;
    }

    /* Check the first selectable option if nothing is checked, then ALWAYS
       re-announce the current choice.

       The re-announce matters: update() in this same file only runs off a
       change event. On the first pass we fire one before the theme has
       bound its listener, so it is missed - and every later pass used to
       bail out early because something was checked by then, which left the
       button stuck on "Select color & size" with a variant plainly chosen.
       Announcing unconditionally costs nothing and makes the later passes
       do the work the first one could not. */
    function selectGroup(root, selector){
      var inputs = [].slice.call(root.querySelectorAll(selector));

      /* The theme renders the colour and size selectors TWICE - a .pdp-desk
         set and a .pdp-mobile set - and only one is ever displayed. Without
         this filter the first match in DOM order can be a control inside the
         hidden set: the variant gets chosen and the button goes live, but
         the row the shopper can actually see still shows nothing selected.
         Keep only controls whose own wrapper is rendered. */
      inputs = inputs.filter(function(i){
        var wrap = i.closest('.selector-wrapper') || i.closest('fieldset') || i.parentElement;
        if (!wrap) return false;
        var r = wrap.getBoundingClientRect();
        return r.height > 0 && r.width > 0;
      });

      if (!inputs.length) return false;

      var current = inputs.filter(function(i){ return i.checked; })[0];

      if (!current){
        current = firstSelectable(inputs);
        if (!current) return false;
        current.checked = true;
      }

      current.dispatchEvent(new Event('input',  { bubbles: true }));
      current.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function init(){
      /* only the selector set that is actually rendered — the theme ships a
         parallel .pdp-mobile set that stays display:none at every width */
      var roots = [].slice.call(document.querySelectorAll('.product__selectors'))
        .filter(function(el){ return el.getBoundingClientRect().height > 0; });
      if (!roots.length) return false;

      var changed = false;
      roots.forEach(function(root){
        if (selectGroup(root, '.radio__fieldset--swatches input[type="radio"]')) changed = true;
        if (selectGroup(root, '.selector-wrapper--size input[type="radio"]'))    changed = true;
      });
      return changed;
    }

    /* the selectors are rendered server-side but the theme re-binds them
       after load, so try once now and twice more as it settles */
    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    function settle(){
      var btn = document.querySelector('[data-add-to-cart]');
      if (btn && !btn.disabled) return;   /* already live, nothing to do */
      init();
    }
    setTimeout(settle, 400);
    setTimeout(settle, 1200);
    setTimeout(settle, 2500);
  })();


  /* ---- mirror :checked onto a class. 15 Sep 2026 ----
     The selected-size box would not paint from :checked. The selector
     matched (confirmed with Element.matches in the page) and the rule was
     !important and last, but the computed border-color stayed transparent -
     three different selector shapes, including :has(), all lost to
     something in this theme's cascade that I could not identify.

     Rather than keep escalating specificity against an unknown opponent,
     mirror the state onto a class and style that. A class beats a
     pseudo-class for debuggability anyway: you can see it in the inspector.

     This only reflects form state that is already true. It does not choose
     anything or rewrite any copy. */
  (function npMirrorChecked(){
    function sync(){
      document.querySelectorAll('.radio__button').forEach(function(btn){
        var input = btn.querySelector('input[type="radio"]');
        var label = btn.querySelector('label');
        if (!input || !label) return;
        label.classList.toggle('np-sel', !!input.checked);
        btn.classList.toggle('np-sel-wrap', !!input.checked);

        /* The class alone would not paint. Four selector shapes - sibling,
           :has(), a plain class, all !important and last in the file - were
           confirmed to MATCH this label with Element.matches() and still lost
           the cascade to something in this theme I could not pin down.
           An inline !important outranks every stylesheet rule, so the box is
           written directly. If someone later finds the offending rule, delete
           this and go back to the class in the stylesheet. */
        if (input.checked) {
          label.style.setProperty('border', '1px solid #792525', 'important');
          label.style.setProperty('color', '#1c1a17', 'important');
        } else {
          label.style.removeProperty('border');
          label.style.removeProperty('color');
        }
      });
    }
    sync();
    document.addEventListener('change', function(e){
      if (e.target && e.target.type === 'radio') setTimeout(sync, 0);
    }, true);
    document.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('.radio__button')) setTimeout(sync, 30);
    }, true);
    setTimeout(sync, 600);
    setTimeout(sync, 1600);
    setTimeout(sync, 3000);
  })();

})();
